import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-on-top-alert-banner',
  templateUrl: './on-top-alert-banner.component.html'
})
export class OnTopAlertBannerComponent implements OnInit {
  @Input() Texts: {title:string, message: string, closable?: boolean, closed?: boolean}
  constructor() { }

  ngOnInit(): void {
  }

}
